import genReducer from '../core/reducer';
import types from './types';
import initialState from './initialState';

export const MEDIA_MODEL = 'media';

export default genReducer(types, initialState);
